/* eslint-disable no-mixed-operators */
import { IRefinements, ISearchResultItem, ISearchResultsObj } from "./types";
import { FeberApiClient } from "../../services/commonServices";
import { convertToSkip } from "../../utils/converter";
import Helper from "../../core/libraries/Helper";


export const getSearchResultsService = async (
    options: IRefinements,
    hasRnDUserRole: boolean | undefined
) => {
    let searchResultsObj: ISearchResultsObj = {
        results: [],
        count: 0,
        top: options.numberOfResults,
        skip: convertToSkip(options.pageNumber, options.numberOfResults),
    };

    let filterString = Helper.makeFilterString(options, hasRnDUserRole);

    let searchOptions = {
        keyword: `${options.keyword}`,
        top: options.numberOfResults,
        skip: convertToSkip(options.pageNumber, options.numberOfResults),
        includeTotalCount: true,
        filter: filterString,
        orderBy: options.sortList,
        select: options.select,
        searchIndexName:"feber-document-ix"
    };
    try {
        const searchResponse = (await FeberApiClient.post("Search", { ...searchOptions })).data as ISearchResultsObj;
        for await (const result of searchResponse.results) {
            let retrievedDocument = result as ISearchResultItem
            let authors = !!retrievedDocument.Authors ? retrievedDocument.Authors : []
            retrievedDocument.Authors = authors;
            searchResultsObj.results.push(retrievedDocument);
        }
        searchResultsObj.count = searchResponse.count;
    } catch (error) {
        console.log(error);
    }
    return searchResultsObj;
}